export default function EbookSection() {
  return null;
}
